(function () {
  var STORAGE_KEY = 'wishlistItem';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(
      new CustomEvent('wishlist:updated', { detail: items })
    );
  }

  function isInWishlist(handle) {
    if (!handle) return false;
    var items = getWishlist();
    return items.indexOf(handle) > -1;
  }

  function addToWishlist(handle) {
    if (!handle) return;

    var items = getWishlist();
    if (items.indexOf(handle) === -1) {
      items.push(handle);
      saveWishlist(items);
    }
  }

  function removeFromWishlist(handle) {
    if (!handle) return;

    var items = getWishlist().filter(function (item) {
      return item !== handle;
    });

    saveWishlist(items);
  }

  function toggleWishlist(handle) {
    if (!handle) return;

    if (isInWishlist(handle)) {
      removeFromWishlist(handle);
    } else {
      addToWishlist(handle);
    }
  }

  function syncHeaderCount() {
    var count = getWishlist().length;
    var countEls = document.querySelectorAll('[data-sc-wishlist-count], .header__icon--wishlist .count, .header__icon--wishlist-count');

    countEls.forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('has-items', count > 0);
    });
  }

  function syncButtons(scope) {
    var root = scope || document;

    var themeButtons = root.querySelectorAll('[data-wishlist][data-wishlist-handle]');
    themeButtons.forEach(function (btn) {
      var handle = btn.getAttribute('data-wishlist-handle');
      var active = isInWishlist(handle);

      btn.classList.toggle('wishlist-added', active);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('title', active ? 'Added to wishlist' : 'Add to wishlist');
      btn.setAttribute('aria-label', active ? 'Added to wishlist' : 'Add to wishlist');

      var textEl = btn.querySelector('.text');
      if (textEl) {
        textEl.textContent = active ? 'Added to wishlist' : 'Add to wishlist';
      }
    });
  }

  document.addEventListener('click', function (e) {
    var themeBtn = e.target.closest('[data-wishlist][data-wishlist-handle]');
    if (!themeBtn) return;

    e.preventDefault();
    e.stopPropagation();

    var handle = themeBtn.getAttribute('data-wishlist-handle') || '';
    if (!handle) return;

    toggleWishlist(handle);
    syncButtons();
    syncHeaderCount();
  }, true);

  document.addEventListener('wishlist:updated', function () {
    syncButtons();
    syncHeaderCount();
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncButtons();
    syncHeaderCount();
  });

  window.scWishlist = {
    getWishlist: getWishlist,
    addToWishlist: addToWishlist,
    removeFromWishlist: removeFromWishlist,
    isInWishlist: isInWishlist,
    syncButtons: syncButtons
  };
})();


function updateWishlistCount() {
  try {
    var items = JSON.parse(localStorage.getItem('wishlistItem')) || [];
    var count = items.length;

    document.querySelectorAll('.wishlist-count-badge').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-block' : 'none';
    });

  } catch (e) {}
}

// 页面加载
document.addEventListener('DOMContentLoaded', updateWishlistCount);

// 每次更新 wishlist 时触发
document.addEventListener('wishlist:updated', updateWishlistCount);